/**
 * "247/750 characters" hint for a capped text field.
 *
 * Fields that mirror a server limit carry a `maxLength`, which means the input
 * silently stops accepting characters once you reach it. That silence is the
 * confusing part, so this surfaces the count as you approach the cap — and
 * announces it politely, since a sighted user sees the typing stop and a
 * screen-reader user otherwise gets nothing at all.
 */

// Below this fraction of the limit the count is noise, not information.
const VISIBLE_FROM = 0.8;

export function CharCount({
  value,
  max,
  className = "",
}: {
  value: string;
  max: number;
  className?: string;
}) {
  if (value.length < max * VISIBLE_FROM) return null;

  const atLimit = value.length >= max;
  return (
    <p
      aria-live="polite"
      className={`mt-1 text-xs ${atLimit ? "text-red-600 font-medium" : "text-muted-foreground"} ${className}`}
    >
      {value.length}/{max} characters{atLimit ? " — limit reached" : ""}
    </p>
  );
}
